import React from 'react';
import { InputNumber } from 'primereact/inputnumber';
import { FormField } from '../../FormField/FormField';
import { FormFieldMessage } from '../../ConditionalFieldMessage/ConditionalFieldMessage';
import { Reservation } from '../../../types/reservation';
import { ReservationFormFieldProps } from '../types';

interface Props extends ReservationFormFieldProps {
  isEditable: boolean;
  required: boolean;
  hasSelectedExternalUsers: boolean;
  resource: Reservation | undefined;
}

/** The price of the session, or how it was paid. */
export const PriceField = ({
  form,
  setFormFields,
  validationErrors,
  isEditable,
  required,
  hasSelectedExternalUsers,
  resource,
}: Props) => {
  return (
    <FormField
      labelTitle='Precio de la sesión'
      elementId='reservation-price'
      fullWidth
      error={validationErrors?.price}
      required={required}
    >
      {isEditable ? (
        <>
          {hasSelectedExternalUsers && (
            <div className='p-inputgroup'>
              <InputNumber
                inputId='reservation-price'
                invalid={!!validationErrors?.price}
                useGrouping={false}
                placeholder='Ej: 40'
                value={form?.price}
                disabled={form?.useCoupon}
                onChange={(e) =>
                  setFormFields({
                    price: e.value ?? undefined,
                  })
                }
              />
              <span className='p-inputgroup-addon'>€</span>
            </div>
          )}
          {!hasSelectedExternalUsers && <FormFieldMessage message='Selecciona un cliente' />}
        </>
      ) : (
        <div className='form-field-row'>
          <span className='price-value'>{form?.price || form?.price === 0 ? `${form.price} €` : '-'}</span>
          {form?.userCouponId && (
            <small className='price-info note'>{resource?.price ? 'Bono adquirido' : 'Pagado con bono'}</small>
          )}
        </div>
      )}
    </FormField>
  );
};
